import React from 'react';
import './PageLoader.css';

export default function PageLoader() {
    return (
        <div className="loader-container">  
            <img src="/app/Image/MainLogo.png" alt="Logo" className="loader-logo" />
            <div className="loader-card">
                <div className="loader-spinner"></div>
                <p>Loading, please wait...</p>
            </div>
            
        </div>
    );
}